import * as React from 'react';

import {
  NotificationModal,
  useOpenNotificationModal
} from 'catering/components/Modals/NotificationModals/NotificationModal';
import { PrimaryCta } from 'components/Buttons';

const MenuItemUnavailableNotificationModal = () => {
  const handlePrimaryCtaClick = () => {
    window.location.reload();
  };

  return (
    <NotificationModal
      title="Uh oh! This item is no longer available"
      text="Please refresh the page to continue."
    >
      <PrimaryCta
        label="Refresh"
        handleClick={handlePrimaryCtaClick}
        fullWidth
      />
    </NotificationModal>
  );
};

export const useOpenMenuItemUnavailableNotificationModal = () =>
  useOpenNotificationModal(<MenuItemUnavailableNotificationModal />);
